module.exports = __webpack_public_path__ + "media/images/icons/hand_dollar-f02db61ac79614e7a1a097e25fece72f.svg";